import React, { useEffect, useState } from "react";
import HorizontalTimeline from "react-horizontal-timeline";
import "./Expereice.css";
import Card from "@mui/material/Card";

const experiences = [
  {
    date: "2023-02-02",
    title: "10x Academy Apprenticeship (Feb - Nov 2023)",
    description:
      "Completed a hands-on apprenticeship at 10x Academy, mastering the MERN stack (MongoDB, Express.js, React.js, Node.js). Developed real-world projects like e-commerce, survey management, and recipe apps, solidifying my web development skills (HTML, CSS, JS). Key Takeaways Strong foundation in MERN stack development Hands-on experience building real-world web apps Proficient in HTML, CSS, and JavaScript",
  },
  {
    date: "2024-12-20",
    title: "Software Developer Peracto Infotech Pvt Ltd (Dec 2023 - June 2024)",
    description:
      "Led the development of a React-based project from initial client requirements to deployment. Visited client sites to gather requirements, ensuring project specifications were clear and met client needs Developed a Word plugin using the Word JavaScript API, enhancing document processing capabilities Created Excel plugins to automate data manipulation tasks,improving efficiency Worked on both front-end (React.js) and back-end (Node.js) components of web applications.Implemented RESTful APIs for seamless communication between front-end and back- end systems Managed project timelines, coordinated with team members, and ensured the successful delivery of projects.",
  },
];

const Experience = () => {
  const [value, setValue] = React.useState(0); // State for the current timeline index

  // Handle timeline index click
  const handleIndexClick = (index) => {
    setValue(index);
  };

  const [dimensions, setDimensions] = useState({
    labelWidth: window.innerWidth < 600 ? 100 : 700,
    linePadding: window.innerWidth < 600 ? 80 : 200,
  });

  const screenWidth = window.innerWidth;
  console.log("screenWidth", screenWidth);

  useEffect(() => {
    const handleResize = () => {
      setDimensions({
        labelWidth: window.innerWidth < 600 ? 100 : 700,
        linePadding: window.innerWidth < 600 ? 80 : 200,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Card sx={{ marginTop: "20px" }}>
      <div className="mt-4 ">
        <div
          style={{
            width: "100%",
            height: "100px",
            margin: "10px auto",
            backgroundColor: "white",
          }}
        >
          <HorizontalTimeline
            index={value}
            indexClick={handleIndexClick}
            values={experiences.map((experience) => experience.date)}
            slidingMotion={{ stiffness: 150, damping: 50 }}
            fillingMotion={{ stiffness: 150, damping: 50 }}
            // labelWidth = {700}
            // linePadding = {200}
            labelWidth={dimensions.labelWidth}
            linePadding={dimensions.linePadding}
            styles={{
              background: "#f8f8f8", // Background color of the timeline
              foreground: "#9100C3", // Foreground (active line) color
              outline: "lightgrey", // Outline (line) color
            }}
          />
        </div>
        <div className="text-center">
          <h5>{experiences[value].title}</h5>
          <p>{experiences[value].description}</p>
        </div>
      </div>
    </Card>
  );
};

export default Experience;
